/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_additional_information = /** @type {(inputs: {}) => string} */ () => {
	return `Další informace`
};

const da_additional_information = /** @type {(inputs: {}) => string} */ () => {
	return `Yderligere information`
};

const de_additional_information = /** @type {(inputs: {}) => string} */ () => {
	return `Zusätzliche Informationen`
};

const en_additional_information = /** @type {(inputs: {}) => string} */ () => {
	return `Additional information`
};

const es_additional_information = /** @type {(inputs: {}) => string} */ () => {
	return `Información adicional`
};

const fr_additional_information = /** @type {(inputs: {}) => string} */ () => {
	return `Informations complémentaires`
};

const hu_additional_information = /** @type {(inputs: {}) => string} */ () => {
	return `További információk`
};

const it_additional_information = /** @type {(inputs: {}) => string} */ () => {
	return `Informazioni aggiuntive`
};

const nl_additional_information = /** @type {(inputs: {}) => string} */ () => {
	return `Aanvullende informatie`
};

const pl_additional_information = /** @type {(inputs: {}) => string} */ () => {
	return `Dodatkowe informacje`
};

const pt_additional_information = /** @type {(inputs: {}) => string} */ () => {
	return `Informações adicionais`
};

const sv_additional_information = /** @type {(inputs: {}) => string} */ () => {
	return `Ytterligare information`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const additional_information = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.additional_information(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("additional_information", locale)
	if (locale === "cs") return cs_additional_information(inputs)
	if (locale === "da") return da_additional_information(inputs)
	if (locale === "de") return de_additional_information(inputs)
	if (locale === "en") return en_additional_information(inputs)
	if (locale === "es") return es_additional_information(inputs)
	if (locale === "fr") return fr_additional_information(inputs)
	if (locale === "hu") return hu_additional_information(inputs)
	if (locale === "it") return it_additional_information(inputs)
	if (locale === "nl") return nl_additional_information(inputs)
	if (locale === "pl") return pl_additional_information(inputs)
	if (locale === "pt") return pt_additional_information(inputs)
	return sv_additional_information(inputs)
};